import { DotsThree, Plus } from '@phosphor-icons/react';

import { Button } from '../ui/Button';

/** `.pen` `ds/form/picker-actions`. */
export function QuickCreatePickerFooter({
  onAdd,
  addLabel,
  addAriaLabel,
  onShowMore,
  moreCount = 0,
  moreLabel,
  isDimmed = false,
}) {
  const showMore = Boolean(onShowMore) && moreCount > 0;
  if (!onAdd && !showMore) return null;

  return (
    <div className="flex items-center gap-space-2">
      {onAdd ? (
        <Button
          type="button"
          variant="secondary"
          size="sm"
          disabled={isDimmed}
          onClick={onAdd}
          aria-label={addAriaLabel || addLabel}
          className="flex-1 justify-center"
        >
          <Plus size={15} className="shrink-0" aria-hidden />
          {addLabel}
        </Button>
      ) : null}
      {showMore ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          disabled={isDimmed}
          onClick={onShowMore}
          aria-label={`${moreLabel} (${moreCount})`}
          className="flex-1 justify-center"
        >
          <DotsThree size={15} className="shrink-0" aria-hidden />
          {moreLabel}
        </Button>
      ) : null}
    </div>
  );
}
